import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import MetricRow from '../../components/MetricRow/MetricRow';
import MetricCard from '../../components/MetricCard/MetricCard';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import styles from './StudyReview.module.css';

const StudyReview = () => {
  const navigate = useNavigate();
  const [showRequestChangesModal, setShowRequestChangesModal] = useState(false);
  const [selectedFix, setSelectedFix] = useState('Venue address');
  const [message, setMessage] = useState('Please add the full Mumbai venue address so we can share it with confirmed participants.');

  const fixOptions = [
    'Venue address',
    'Screener question',
    'Incentive too low',
    'Eligibility unclear',
    'Asks for personal data'
  ];

  const headerActions = (
    <>
      <Button
        variant="secondary"
        onClick={() => setShowRequestChangesModal(true)}
      >
        Request changes
      </Button>
      <Button
        variant="primary"
        onClick={() => navigate('/study-approved')}
      >
        Approve study
      </Button>
    </>
  );

  const modalFooter = (
    <>
      <Button
        variant="secondary"
        onClick={() => setShowRequestChangesModal(false)}
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        onClick={() => {
          setShowRequestChangesModal(false);
          navigate('/approvals');
        }}
      >
        Send to researcher
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        backTo="/approvals"
        backText="← Study approvals"
        title="Mobile Gaming Behaviour – Android"
        subtitle="Submitted 18h ago by Insight Loop Research"
        actions={headerActions}
      />

      <MetricRow columns={3}>
        <MetricCard label="Seats" value="12" subtext="participants" />
        <MetricCard label="Incentive" value="₹5000" subtext="per participant" />
        <MetricCard label="Auto-check" value="1 issue" subtext="venue" />
      </MetricRow>

      <div className={styles.mainGrid}>
        <section className={styles.overviewCard}>
          <div className={styles.cardHeader}>
            <h2 className={styles.cardTitle}>Study overview</h2>
            <span className={styles.typeBadge}>Focus group</span>
          </div>
          <div className={styles.overviewText}>
            Evaluating gamer attitudes towards emerging Android cloud gaming applications and monetization mechanics. 90-minute in-person session across Delhi and Mumbai centers.
          </div>
          <div className={styles.sectionBlock}>
            <div className={styles.sectionLabel}>TARGET AUDIENCE</div>
            <div className={styles.pillGroup}>
              <span className={styles.audiencePill}>Age: 18–32</span>
              <span className={styles.audiencePill}>OS: Android 12+</span>
              <span className={styles.audiencePill}>Playtime: &gt;5 hrs/week</span>
              <span className={styles.audiencePill}>Location: Delhi, Mumbai</span>
            </div>
          </div>
          <div className={styles.sectionBlock}>
            <div className={styles.sectionLabel}>SCREENER QUESTIONS</div>
            <div className={styles.questionList}>
              <div>1. Which mobile games do you currently play most actively?</div>
              <div>2. Have you made in-app purchases in the last 30 days?</div>
              <div>3. Are you available for a 90-minute in-person group session?</div>
            </div>
          </div>
        </section>

        <div className={styles.sideColumn}>
          <section className={styles.infoCard}>
            <h2 className={styles.cardTitle}>Researcher info</h2>
            <div className={styles.infoRow}>
              <span className={styles.infoLabel}>Organization</span>
              <span className={styles.infoValue}>Insight Loop Research</span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.infoLabel}>Plan</span>
              <span className={`${styles.infoValue} ${styles.primaryValue}`}>Pro (Verified)</span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.infoLabel}>Studies run</span>
              <span className={styles.infoValue}>14 completed</span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.infoLabel}>Researcher rating</span>
              <span className={`${styles.infoValue} ${styles.successValue}`}>4.9 / 5.0</span>
            </div>
          </section>

          <section className={styles.infoCard}>
            <h2 className={styles.cardTitle}>Budget breakdown</h2>
            <div className={styles.infoRow}>
              <span className={styles.infoLabel}>12 Seats × ₹5,000</span>
              <span className={styles.infoValue}>₹60,000</span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.infoLabel}>Platform fee (10%)</span>
              <span className={styles.infoValue}>₹6,000</span>
            </div>
            <div className={styles.totalRow}>
              <span className={styles.infoValue}>Total held in escrow</span>
              <span className={`${styles.infoValue} ${styles.primaryValue}`}>₹66,000</span>
            </div>
          </section>
        </div>
      </div>

      <Modal
        isOpen={showRequestChangesModal}
        onClose={() => setShowRequestChangesModal(false)}
        title="Request changes"
        subtitle="The researcher gets this in their dashboard and by email. The study stays hidden until they resubmit."
        footer={modalFooter}
        maxWidth={520}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '12px', fontWeight: 500 }}>
          <span>What needs fixing</span>
          <div className={styles.fixOptionGroup}>
            {fixOptions.map((option) => (
              <button
                key={option}
                type="button"
                onClick={() => setSelectedFix(option)}
                className={`${styles.fixOptionBtn} ${selectedFix === option ? styles.fixOptionBtnActive : ''}`.trim()}
              >
                {option}
              </button>
            ))}
          </div>
        </div>

        <label style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '12px', fontWeight: 500 }}>
          <span>Message to researcher</span>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className={styles.textareaField}
          />
        </label>
      </Modal>
    </>
  );
};

export default StudyReview;
